import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  ToastContainer,
  ToastMessage,
  ToastText,
  ToastDismiss,
  LoadingSpinner,
} from './styles.module'
import { Success, ErrorIcon } from '../../assets/icons'
import colors from '../../styled/colors'
import { hideToast } from '../../actions'

const AUTO_HIDE_DELAY = 5000

const Toast = ({ visible, message, type, position, hideToast }) => {
  useEffect(() => {
    if (visible && type !== 'loading') {
      const timeoutId = setTimeout(() => {
        hideToast()
      }, AUTO_HIDE_DELAY)

      return () => clearTimeout(timeoutId)
    }
  }, [visible, type, hideToast])

  if (!visible) return null

  return (
    <ToastContainer position={position} type={type}>
      <ToastMessage>
        {type === 'success' && (
          <Success color={colors.feedback.success} width="24px" height="24px" />
        )}

        {type === 'error' && (
          <ErrorIcon color={colors.feedback.error} width="24px" height="24px" />
        )}

        {type === 'loading' && <LoadingSpinner />}

        <ToastText>{message}</ToastText>
      </ToastMessage>

      {type !== 'loading' && (
        <ToastDismiss type={type} onClick={hideToast}>
          ACEPTAR
        </ToastDismiss>
      )}
    </ToastContainer>
  )
}

const mapStateToProps = state => ({
  visible: state.toast.visible,
  message: state.toast.message,
  type: state.toast.type,
  position: state.toast.position,
})

const mapDispatchToProps = {
  hideToast,
}

export default connect(mapStateToProps, mapDispatchToProps)(Toast)